import * as React from 'react';

const GeoContext = React.createContext<number | null>(null);

export const Provider = GeoContext.Provider;
export const Consumer = GeoContext.Consumer;
export default GeoContext;
